import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const FilterLine = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M3 6H21M6 12H18M10 18H14", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }) }), props);
FilterLine.iconName = 'filter';
FilterLine.displayName = 'FilterLine';
export default FilterLine;
